import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";

interface IGetAmplitudeSemanticSearchPropertyListItemParams {
    property: SemanticSearchPropertyDto;
    index: number;
}

// SemanticSearchPropertyDto nie ma pola `currency` (usluga tylko dla Polski, wiec na sztywno PLN/Polska) ani
// `region.stats.region_type_voivodeship` (jest tylko `region_type_county` - powiat, nie wojewodztwo) - stad brak item_category3.
export const getAmplitudeSemanticSearchPropertyListItem = ({property, index}: IGetAmplitudeSemanticSearchPropertyListItemParams) => {
    const stats = property.offer.region.stats;

    return {
        item_id: property.offer.id,
        property_id: property.id,
        item_name: property.offer.name,
        item_address: property.offer.address,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_category2: "Polska",
        item_category4: stats?.region_type_city?.name || stats?.region_type_town?.name || null,
        item_category5: stats?.region_type_district?.name || null,
        item_type: property.type,
        variant_area: property.area,
        variant_rooms: property.rooms,
        variant_floor: property.floor,
        currency: "PLN",
        price: property.price,
        index
    } satisfies Record<string, string | number | null>;
};
import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";

interface IGetAmplitudeSemanticSearchPropertyListItemParams {
    property: SemanticSearchPropertyDto;
    index: number;
}

// SemanticSearchPropertyDto nie ma pola `currency` (usluga tylko dla Polski, wiec na sztywno PLN/Polska) ani
// `region.stats.region_type_voivodeship` (jest tylko `region_type_county` - powiat, nie wojewodztwo) - stad brak item_category3.
export const getAmplitudeSemanticSearchPropertyListItem = ({property, index}: IGetAmplitudeSemanticSearchPropertyListItemParams) => {
    const stats = property.offer.region.stats;

    return {
        item_id: property.offer.id,
        property_id: property.id,
        item_name: property.offer.name,
        item_address: property.offer.address,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_category2: "Polska",
        item_category4: stats?.region_type_city?.name || stats?.region_type_town?.name || null,
        item_category5: stats?.region_type_district?.name || null,
        item_type: property.type,
        variant_area: property.area,
        variant_rooms: property.rooms,
        variant_floor: property.floor,
        currency: "PLN",
        price: property.price,
        index
    } satisfies Record<string, string | number | null>;
};
